import UserService from "api/user/user";
import React from 'react';
import { useProspectPageContext } from "v4/contexts/ProspectPageContext";
import BaseQuoteTabShow
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseQuoteTabShow/BaseQuoteTabShow";
import ProspectWonQuoteIntranetButton
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectWonQuotesTab/components/ProspectWonQuoteTabShow/components/ProspectWonQuoteIntranetButton/ProspectWonQuoteIntranetButton";

export default function ProspectWonQuoteTabShow(props) {
    const { quote, prospect } = useProspectPageContext();

    return (
        <BaseQuoteTabShow
            {...props}
            specificButtonsByOrder={[
                {
                    order: 4,
                    component: (UserService.hasIntranet() && quote && prospect) && (
                        <ProspectWonQuoteIntranetButton/>
                    )
                },
            ]}
        />
    )
}
